import { useState } from "react";
import { toast } from "sonner";
import { CalendarX, Loader2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { withBooking, withPhone } from "@/lib/liSequences";

// No-show rescue: backend drafts a rebook email ~1h after a no-show; nothing sends until approved here.
export const RescueBox = ({ p, onDone }) => {
  const r = p.rescue_draft;
  const [d, setD] = useState(r ? { subject: r.subject || "", body: r.body || "" } : null);
  const [busy, setBusy] = useState("");
  if (!r || r.status === "sent" || r.status === "dismissed") return null;
  const act = async (kind) => {
    if (kind === "send" && (!d.subject.trim() || !d.body.trim())) return toast.error("Add a subject and message.");
    setBusy(kind);
    try { await api.post(`/admin/rcc/li/prospects/${p.id}/rescue/${kind}`, kind === "send" ? { ...d, body: withPhone(withBooking(d.body, p.id)) } : {}); toast.success(kind === "send" ? `Rebook email sent to ${p.email}` : "Rebook email dismissed"); onDone(); }
    catch (e) { toast.error(e.response?.status === 404 ? "No-show rescue isn't live on the backend yet (spec §36.7)." : errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div className="basis-full space-y-2 rounded-xl border border-amber-500/40 bg-amber-500/5 p-3" data-testid={`li-rescue-${p.id}`}>
      <p className="flex items-center gap-2 text-xs font-semibold text-amber-200"><CalendarX className="h-4 w-4" />No-show rescue: rebook email ready for your approval</p>
      <Input value={d.subject} onChange={(e) => setD({ ...d, subject: e.target.value })} className="h-8 text-xs" data-testid={`li-rescue-${p.id}-subject`} />
      <Textarea rows={6} value={d.body} onChange={(e) => setD({ ...d, body: e.target.value })} className="text-sm" data-testid={`li-rescue-${p.id}-body`} />
      <div className="flex gap-2"><Button size="sm" onClick={() => act("send")} disabled={!!busy} className="h-8 bg-[#D4AF37] text-black" data-testid={`li-rescue-${p.id}-send`}>{busy === "send" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />}Approve & send</Button>
        <Button size="sm" variant="outline" onClick={() => act("dismiss")} disabled={!!busy} className="h-8 border-[#27272A]" data-testid={`li-rescue-${p.id}-dismiss`}>Dismiss</Button></div>
      <p className="text-[10px] text-zinc-600">Includes their personal booking link and your phone number.</p>
    </div>
  );
};
